
export function spearmanCorrelation(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    throw new Error("Both inputs must be arrays.");
  }

  // Determine common length (smallest array size)
  const n = Math.min(arr1.length, arr2.length);
  if (n === 0) return null;

  // Take last n elements from both arrays
  const x = arr1.slice(-n);
  const y = arr2.slice(-n);

  // Helper: rank an array (average ranks for ties)
  function rankArray(arr) {
    const sorted = [...arr].slice().sort((a, b) => a - b);
    return arr.map(val => {
      const indices = sorted
        .map((v, i) => (v === val ? i + 1 : null))
        .filter(i => i !== null);
      const avgRank = indices.reduce((a, b) => a + b, 0) / indices.length;
      return avgRank;
    });
  }

  const rankX = rankArray(x);
  const rankY = rankArray(y);

  // Compute Spearman correlation
  const meanX = rankX.reduce((a, b) => a + b, 0) / n;
  const meanY = rankY.reduce((a, b) => a + b, 0) / n;

  let numerator = 0;
  let denomX = 0;
  let denomY = 0;

  for (let i = 0; i < n; i++) {
    const dx = rankX[i] - meanX;
    const dy = rankY[i] - meanY;
    numerator += dx * dy;
    denomX += dx * dx;
    denomY += dy * dy;
  }

  return numerator / Math.sqrt(denomX * denomY);
}


export function getHistoricValues(historicPrices) {
  if (!historicPrices || typeof historicPrices !== "object") {
    throw new Error("historicPrices deve ser um objeto chave-valor (ex: {2015: 1.23, ...}).");
  }

  const years = Object.keys(historicPrices)
    .map(Number)
    .sort((a, b) => a - b);

  const values = years.map((year) => historicPrices[year]);
  return values;
}

